import { useTranslation } from "react-i18next";

import { CALCULATOR_TYPES } from "constants/calculator";

import PlusIcon from "assets/icons/plus.svg?react";

import { MAX_STAGES_LIMIT } from "constants/calculator";

import { Button } from "shared/ui/components/Button";

import styles from "./StagesActions.module.scss";

const StagesActions = ({
  values,
  calculatorType,
  onAddStageClick,
}: {
  values: any;
  onSortByDateClick?: () => void;
  onAddStageClick: () => void;
  calculatorType: (typeof CALCULATOR_TYPES)[keyof typeof CALCULATOR_TYPES];
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <Button
        className={styles.trigger}
        onClick={onAddStageClick}
        variant="tertiary"
        size="small"
        endIcon={<PlusIcon className={styles.triggerIcon} />}
        disabled={
          values.stages.length >= MAX_STAGES_LIMIT ||
          (calculatorType !== CALCULATOR_TYPES.STANDARD && calculatorType !== CALCULATOR_TYPES.EXPERT)
        }
      >
        {t("calculator_form.stages.add_stage")}
      </Button>
    </div>
  );
};

export default StagesActions;
